import React, { useState, useEffect } from "react";
import { Space, Tooltip, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Table from "../surgical_intervention/Table";

import { all as AllSurgicalIntervention } from "../../api/SurgicalIntervention";

const DEFAULT_SORTER = {
  column: {
    dataIndex: "expected_end_at",
  },
  columnKey: undefined,
  field: "expected_end_at",
  order: "ascend",
};

/**
 *
 */
const SurgicalInterventionTable = (props) => {
  const { mode, surgicalInterventionIds, transferedSurgicalInterventionIds } = props;

  const [ready, setReady] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [loading, setLoading] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
  });
  const [sorter, setSorter] = useState({ ...DEFAULT_SORTER });
  const [surgicalInterventions, setSurgicalInterventions] = useState([]);
  const [showSearchInfo, setShowSearchInfo] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  let timeoutSearchValue = null;

  /**
   *
   * @param {*} filtersStorage
   */
  const loadFiltersStorage = (filtersStorage) => {
    if (!filtersStorage) {
      setReady(true);
      return;
    }

    filtersStorage = JSON.parse(filtersStorage);

    Object.keys(filtersStorage).forEach(item => {
      if (item === "pagination") {
        setPagination({ ...filtersStorage[item] });
      } else if (item === "sorter") {
        setSorter({ ...filtersStorage[item] });
      }
    });
    setReady(true);
  }

  /**
   *
   */
  const storeFiltersStorage = (pagination, filters, sorter) => {
    let filtersTable = JSON.stringify({
      "pagination": {
        "current": pagination.current,
        "pageSize": pagination.pageSize,
      },
      "sorter": sorter,
    });

    localStorage.setItem('filters_surgical_intervention_table', filtersTable);
  };

  /**
   *
   * @param {*} pagination
   * @param {*} filters
   * @param {*} sorter
   * @returns
   */
  const getPayload = (pagination, filters, sorter) => {
    let payload = {
      current: pagination.current,
      pageSize: pagination.pageSize,
    };

    if (searchValue || surgicalInterventionIds) {
      payload["q"] = {};

      if (searchValue) {
        payload.q["search"] = searchValue;
      }

      if (surgicalInterventionIds) {
        payload.q["_id"] = surgicalInterventionIds;
      }
    }

    if (sorter.column === undefined) {
      sorter = { ...DEFAULT_SORTER };
    }

    let { order, column } = sorter;
    let field = column.columnKey ? column.columnKey : column.dataIndex;
    order = order === "ascend" ? 1 : -1;

    if (!!field && !!order) {
      payload["sort"] = field + "," + order;
    }

    return payload;
  };

  /**
   *
   * @param {*} pagination
   * @param {*} filters
   * @param {*} sorter
   */
  const fetch = async function (pagination, filters, sorter) {
    setLoading(true);

    let payload = getPayload(pagination, filters, sorter);

    return AllSurgicalIntervention(payload).then((data) => {
      setSurgicalInterventions(data.results);
      setPagination({
        ...pagination,
        total: data.total,
      });
      setSorter({ ...sorter });
      setLoading(false);
      setFirstLoad(false);

      storeFiltersStorage(pagination, filters, sorter);
    });
  };

  /**
   *
   * @param {*} e
   */
  const handleSearchValue = (e) => {
    let value = e.target.value;

    clearTimeout(timeoutSearchValue);

    let searchLength = value.length;
    let searchValid = searchLength === 0 || searchLength > 2;

    timeoutSearchValue = setTimeout(() => {
      setShowSearchInfo(!searchValid);

      if (searchValid) {
        setSearchValue(e.target.value);
      }
    }, 500);
  };

  useEffect(async () => {
    let filtersStorage = localStorage.getItem('filters_surgical_intervention_table', null);
    loadFiltersStorage(filtersStorage);
  }, []);

  useEffect(() => {
    if (!props.ready || !ready) {
      return;
    }

    fetch(
      { ...pagination, current: 1 },
      null,
      sorter
    );
  }, [searchValue]);

  useEffect(() => {
    if (!props.ready || !ready) {
      return;
    }

    if (firstLoad) {
      fetch(pagination, null, sorter);
      return;
    }

    fetch(
      { ...pagination, current: 1 },
      null,
      sorter
    );
  }, [props.ready, ready, surgicalInterventionIds]);

  return (
    <>
      <Space className="mb-4" direction="horizontal" align="start">
        <Space direction="vertical">
          <label>Recherche :</label>
          <Tooltip
            title="La recherche ne s'applique qu'à partir de 3 caractères."
            visible={showSearchInfo}
          >
            <Input
              style={{ width: 400 }}
              suffix={<SearchOutlined />}
              placeholder="Tapez des caractères"
              allowClear={true}
              onChange={handleSearchValue}
            />
          </Tooltip>
        </Space>
      </Space>

      <Table
        mode={mode}
        pagination={pagination}
        sorter={sorter}
        loading={loading}
        surgicalInterventions={surgicalInterventions}
        transferedSurgicalInterventionIds={transferedSurgicalInterventionIds}
        fetch={fetch}
        onChange={props.onChange}
        onEdit={props.onEdit}
        onCancel={props.onChange}
        onOut={props.onOut}
      />
    </>
  );
};

export default SurgicalInterventionTable;
